export default __webpack_public_path__ + "a40624b77509a01e7210c0cb7c5497de.png";